module.exports = __webpack_public_path__ + "img/MZ.e66ee4b7.svg";